<template>
  <div id="paginaPraticheVVF">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Grid View: GridElencoPraticheVVF -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Elenco Pratiche VVF</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id="dropAnniRiferimento" ref="dropAnniRiferimento" :query="queryAnno"
                  :dataSource="annoRiferimentoList" :index="annoIndex" :fields="annoRiferimentoFields"
                  :change="onAnnoRiferimentoChange" v-model="annoRiferimentoCorrente"
                  placeholder="Seleziona un Anno"></ejs-dropdownlist>
              </b-col>
              <!-- Timer Alert -->
              <b-col xl="6" md="12">
                <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                  @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-alert variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown" height="4px" />
                </b-alert>
              </b-col>

              <b-col xl="12" md="12" class="pt-1">
                <ejs-grid id="gridA" ref="gridA" :dataSource="praticheVVFFullData" :allowSorting="true"
                  :sortSettings="gridA.sortOptions" :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions"
                  :height="gridA.height" :allowFiltering="true" :filterSettings="gridA.filterOptions"
                  :editSettings="gridA.editOptions" :actionBegin="gridAactionBegin" :actionComplete="gridAactionComplete">
                  <e-columns>
                    <e-column field="id" headerText="ID" :isPrimaryKey="true" width="60" :visible="false"></e-column>
                    <e-column field="dataCreazione" headerText="Data Creazione" width="80" :format="settings.formatoData"
                      type="date"></e-column>
                    <e-column field="annoRiferimento" headerText="Anno" width="60"></e-column>
                    <e-column field="meseRiferimento" headerText="Mese" width="80"></e-column>
                    <e-column field="oreTotali" headerText="Ore Totali" width="80"></e-column>
                    <e-column field="compensoTotale" headerText="Compenso Totale" width="100"></e-column>
                    <e-column field="tipologia" headerText="Tipologia" width="100" foreignKeyField="val"
                      foreignKeyValue="label" :dataSource="this.praticheVVFTipoList"></e-column>
                    <e-column field="stato" headerText="Stato" width="100" foreignKeyField="val"
                      foreignKeyValue="label" :dataSource="this.praticheVVFStatoList"></e-column>
                  </e-columns>
                </ejs-grid>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- dialogA: dialogDettaglioPraticaVVF ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog id="dialogA" ref="dialogA" :header="dialogA.header" :buttons="dialogA.buttons" :visible="dialogA.visible"
      :showCloseIcon="dialogA.showCloseIcon" :close="dialogAClose" :open="dialogAOpen" :zIndex="dialogA.zIndex"
      :animationSettings="dialogA.animationSettings" :isModal="dialogA.isModal">
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA" v-model="dialogA.tabAdialogAIndex">
        <b-tab title="Dati Pratica VVF" @click="tabClicked('dialogATab01')">
          <b-row class="match-height">
            <!-- Card con Elementi Input: dati pratica VVF -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dati Pratica VVF</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="id" class="h5">Id</label>
                      <ejs-textbox id="id" v-model="praticheVVFActiveData.id" floatLabelType="Never" cssClass=""
                        placeholder="id" showClearButton="true" type="text" autocomplete="false" :readonly="true" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="dataCreazione" class="h5">Data di Creazione</label>
                      <ejs-datepicker id="dataCreazione" v-model="praticheVVFActiveData.dataCreazione"
                        :format="settings.formatoDatepicker" placeholder="Data di Creazione"
                        :firstDayOfWeek="settings.firstDayOfWeek" :readonly="true" />
                    </b-col>

                    <!-- Input di tipo MULTISELECT: praticheVVFActiveData.reciteAssociate                      DA INSERIRE-->

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="annoRiferimento" class="h5">Anno di Riferimento</label>
                      <ejs-dropdownlist id="annoRiferimento" v-model="praticheVVFActiveData.annoRiferimento"
                        :dataSource="annoRiferimentoList" :fields="annoRiferimentoFields" :allowFiltering="true"
                        placeholder="Anno di Riferimento" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="meseRiferimento" class="h5">Mese di Riferimento</label>
                      <ejs-dropdownlist id="meseRiferimento" ref="meseRiferimento" v-model="praticheVVFActiveData.meseRiferimento"
                        :dataSource="meseRiferimentoList" :fields="meseRiferimentoFields" :allowFiltering="true"
                        :change="onMeseChange" placeholder="Mese di Riferimento" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="tariffaOrariaApplicata" class="h5">Tariffa Oraria Applicata</label>
                      <ejs-numerictextbox id="tariffaOrariaApplicata"
                        v-model="praticheVVFActiveData.tariffaOrariaApplicata" floatLabelType="Never" cssClass=""
                        format="€ ###.##" placeholder="Tariffa Oraria Applicata" showSpinButton="false"
                        showClearButton="true" />
                    </b-col>

                    <b-col xl="12" md="12" class="pt-1">
                      <ejs-grid id="gridD" ref="gridD" :dataSource="reciteSpettacoloFullData" :allowSorting="true"
                        :toolbar="gridD.toolbarOptions" :height="gridD.height"
                        :allowFiltering="true" :filterSettings="gridD.filterOptions" :editSettings="gridD.editOptions"
                        :sortSettings='gridD.sortOptions' 
                       >
                        <e-columns>
                          <e-column field="id" headerText="ID" :isPrimaryKey="true" width="30"></e-column>
                          <e-column field="spettacoloName" headerText="Titolo Spettacolo" width="100"></e-column>
                          <e-column field="data" headerText="Data" :format="settings.formatoData" type="date"
                            width="40"></e-column>
                          <e-column field="orario" headerText="Orario" type="time" format="settings.formatoOraGrid"
                            width="40"></e-column>
                          <e-column field="luogo" headerText="Luogo" width="60"></e-column>
                          <e-column field="capienza" headerText="Capienza" width="40"></e-column>
                          <e-column field="vigiliFuoco" headerText="Vigili del Fuoco" width="60"></e-column>
                          <e-column field="siae" headerText="Siae" width="60"></e-column>
                        </e-columns>
                      </ejs-grid>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>

  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  ImagePlugin,
  LinkPlugin,
  AlertPlugin,
  ToastPlugin,
} from "bootstrap-vue";
// import Vuexy

// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
import {
  DateTimePickerPlugin,
  DateRangePickerPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  UploaderPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(ImagePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(UploaderPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api
const apiVueEndPoint = process.env.VUE_APP_API_ENDPOINT;

const apiPraticheVVFUrl = "/demo/api/praticavvf";
const apiPraticheVVFRicercaUrl = "/demo/api/praticavvf/ricerca";
const apiReciteRicercaSpettacoloUrl = "/demo/api/recita/ricerca";
const apiReciteRicercaMeseUrl = "/demo/api/recita/ricerca_mese";


export default Vue.extend({
  components: {},
  data() {
    return {
      dataOggi: new Date(),
      // tmp
      nonMostrare: false, // utile per non cancellare codice in editing
      // generali
      settings: {
        formatoData: { type: "date", format: "dd-MM-yyyy" }, // da usare per grid
        formatoOra: { skeleton: "Hm" },
        //formatoOra: 'HH:mm',
        formatoOraGrid: { type: "dateTime", format: "HH:mm" }, // da usare per grid
        formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
        intervalloOra: 5,
        firstDayOfWeek: 1,
      },
      // praticheVVF
      praticheVVFFullData: [], // elenco completo dati spettacoli
      praticheVVFActiveId: 0, // Id spettacolo attivo (0 se nuovo)
      praticheVVFActiveData: {}, // dati completi dell spettacolo attivo
      praticheVVFSavedData: {}, // dati completi dell spettacolo attivo
      praticheVVFDefaultData: {}, // dati completi di default per nuovi spettacoli

      // per inizializzazione dropdown a null
      initIndex: -1,
      // per gestione annoRiferimento
      annoRiferimentoList: [
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
      ],
      annoRiferimentoFields: { value: "val", text: "label" },
      annoIndex: -1,
      queryAnno: null,
      annoRiferimentoCorrente: null,
      booleanList: [
        { label: "Si", val: true },
        { label: "No", val: false },
      ],
      // per gestione meseRiferimento
      meseRiferimentoList: [
        { label: "Gennaio", val: "01" },
        { label: "Febbraio", val: "02" },
        { label: "Marzo", val: "03" },
        { label: "Aprile", val: "04" },
        { label: "Maggio", val: "05" },
        { label: "Giugno", val: "06" },
        { label: "Luglio", val: "07" },
        { label: "Agosto", val: "08" },
        { label: "Settembre", val: "09" },
        { label: "Ottobre", val: "10" },
        { label: "Novembre", val: "11" },
        { label: "Dicembre", val: "12" },
      ],
      meseRiferimentoFields: { value: "val", text: "label" },
      // lista valori tipologia pratica
      praticheVVFTipoList: [
        { label: "Regolare", val: "regolare" },
        { label: "Aggiuntiva", val: "aggiuntiva" },
      ],
      praticheVVFTipoFields: { text: "label", value: "val" },
      // lista valori stato pratica
      praticheVVFStatoList: [
        { label: "Generato", val: "generato" },
        { label: "Pagato", val: "pagato" },
      ],
      praticheVVFStatoFields: { text: "label", value: "val" },

      // reciteSpettacolo
      reciteSpettacoloFullData: [], // elenco completo delle recite associate ad uno spettacolo
      reciteSpettacoloActiveId: 0, // Id recita attiva (0 se nuovo)
      reciteSpettacoloActiveData: {}, // dati completi della recita attualmente visualizzata
      reciteSpettacoloDefaultData: {},
      // lista valori tipologia recita
      reciteTipologiaList: [
        { label: "Rappresentazione", val: "rappresentazione" },
        { label: "Prova Generale", val: "provaGenerale" },
      ],
      reciteTipologiaFields: { text: "label", value: "val" },
      // lista valori stato recita
      reciteStatoList: [
        { label: "Confermata", val: "confermata" },
        { label: "Annullata", val: "annullata" },
      ],
      reciteStatoFields: { text: "label", value: "val" },
      // lista valori VigiliFuoco recita
      reciteVigiliFuocoList: [
        { label: "Non Necessari", val: "nonNecessari" },
        { label: "Comunicazione Effettuata", val: "comunicazioneEffettuata" },
        {
          label: "Comunicazione non Effettuata",
          val: "comunicazioneNonEffettuata",
        },
      ],
      reciteVigiliFuocoFields: { text: "label", value: "val" },
      // lista valori Siae recita
      reciteSiaeList: [
        { label: "Non Necessaria", val: "nonNecessari" },
        { label: "Comunicazione Effettuata", val: "comunicazioneEffettuata" },
        {
          label: "Comunicazione non Effettuata",
          val: "comunicazioneNonEffettuata",
        },
      ],
      reciteSiaeFields: { text: "label", value: "val" },

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA
      dialogA: {
        header: "",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogAOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogACancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogAIndex: 0,
        isModal: false,
      },
      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuova Pratica VVF",
            tooltipText: "Inserisci nuova Pratica VVF",
            prefixIcon: "e-plus",
            id: "new",
          },
          {
            text: "Cancella Pratica VVF",
            tooltipText: "Cancella Pratica VVF",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          {
            text: "Download Pratica",
            tooltipText: "Download Pratica",
            prefixIcon: "e-save",
            id: "download",
          },
          "Search",
        ],
        sortOptions: { columns: [{ field: "dataInizio", direction: "Ascending" }] },
      },
      // per gridD
      gridDFlag: false,
      gridD: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        sortOptions: { columns: [{ field: "data", direction: "Ascending" }, { field: "orario", direction: "Ascending" }] },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          "Search",
        ],
      }, //


    };
  },
  created() {
    console.log("Pagina PraticheVVF Creata");
    this.annoRiferimentoCorrente = new Date().getFullYear().toString()

    // inizializzazione elenchi dal backend
    // chiamate API

    // recupero elenco PraticheVVF dal backend
    if (localStorage.getItem("userData") !== null) {
      console.log("Recupero elenco PraticheVVF dal backend");
      const datiDaInviare = {
        annoRiferimento: this.annoRiferimentoCorrente,
      };
      useJwt.post(apiPraticheVVFRicercaUrl, datiDaInviare).then((d) => {
        // console.log("PraticheVVF");
        // console.log(d.data);
        this.praticheVVFFullData = d.data;
      });
    } else {
      console.log("Non trovo UserData, prova ancora");
    }

    // Recupero/definisco i valori di default delle entità utilizzate nel componente

    // praticheVVFDefaultData ( esplicitato nei pulsanti "Nuovo.." della gridA )
    this.praticheVVFDefaultData = {};

  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey],
    // per multiselect
    multiselect: [CheckBoxSelection],
  },
  methods: {
    onAnnoRiferimentoChange: function (e) {
      console.log("Change")
      console.log("Recupero elenco PraticheVVF dal backend per l'anno selezionato");
      const datiDaInviare = {
        annoRiferimento: this.annoRiferimentoCorrente,
      };
      useJwt.post(apiPraticheVVFRicercaUrl, datiDaInviare).then((d) => {
        //console.log("PraticheVVF");
        console.log(d.data);
        this.praticheVVFFullData = d.data;
      });
    },

    onMeseChange: function(e) {
      // recupero recite di anno e mese selezionati
      const datiDaInviare = {
        anno: this.praticheVVFActiveData.annoRiferimento,
        mese: this.$refs.meseRiferimento.ej2Instances.value
       }
      // recupera recite
      useJwt.post(apiReciteRicercaMeseUrl, datiDaInviare).then((d) => {
        // console.log("Recite");
        // console.log(d.data);
        this.reciteSpettacoloFullData = d.data;
        // fix aggiornamento orario
        this.reciteSpettacoloFullData.forEach((obj) => {
          if (obj.orario != null) {
            //console.log(obj.orario.slice(11, 16));
            obj.orario = obj.orario.slice(11, 16);
          }
        });

          // ORDINARE PER DATA E ORARIO
          this.reciteSpettacoloFullData.sort(function(a, b) {
              let diff_date = new Date(a.data) - new Date(b.data);
              if (diff_date == 0) {
                  if (a.orario > b.orario) {
                      return 1;
                  }
                  if (a.orario == b.orario) {
                      return 0;
                  }
                  if (a.orario < b.orario) {
                      return -1;
                  }
              }
              return diff_date;
          });
      });
    },
    // per dialogA
    dialogAOpen(args) {
      console.log("Apertura dialogA");
      // assegnare le informazioni da visualizzare nel dialog A
      console.log("PraticaVVF attiva");
      console.log(this.praticheVVFActiveId);
      this.praticheVVFSavedData = { ...this.praticheVVFActiveData };
      // this.imgpraticheVVFActiveId = 0
    

      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogAClose() {
      console.log("Chiusura dialogA");
      this.dialogA.tabAdialogAIndex = 0;
      //console.log(this.praticheVVFActiveData);
    },
    async dialogAOk() {
      let error = false
      console.log("Cliccato bottone OK di dialogA");
      // salvataggio informazioni in remoto
      if (this.praticheVVFActiveId === 0) {
        // salvataggio in caso di new
        const datiDaInviare = {
          pratica: this.praticheVVFActiveData,
          recite: this.reciteSpettacoloFullData,
        };
        error = await useJwt
          .post(apiPraticheVVFUrl, datiDaInviare)
          .then((res) => {
            // TODO: gestione errore creazione
            // if (res.status == 200 || res.status == 201) {
            //   console.log("PraticaVVF CREATA")
            //   //console.log(res.data)
            //   // mi segno ID elemento appena creato
            //   this.praticheVVFActiveId = res.data.id;
            //   this.makeToast( "primary", "Successo", "Creazione della pratica VVF")
            // } else {
            //   this.makeToast( "primary", "ERRORE", "Errore nella creazione della pratica");
            // }
            return this; // restituisci contesto per permettere aggiornamento grid
          })
          .then((context) => {
            const datiDaInviare = {
              annoRiferimento: this.annoRiferimentoCorrente,
            };
            useJwt.post(apiPraticheVVFRicercaUrl, datiDaInviare).then((res) => {
              console.log(
                "Aggiornamento gridA con l'aggiunta di una PraticaVVF"
              );
              context.praticheVVFFullData = res.data;
              context.praticheVVFFullData = [...context.praticheVVFFullData];
              console.log(context.praticheVVFFullData)
            });
            return false
          }).catch(error => {
            let messaggio = ""
            if (error.response) {
              //console.log(error.response.data)
              let chiavi = Object.keys(error.response.data)
              // console.log(error.response.data['soggetto'])
              // console.log(error.response.data['tipologia'])
              chiavi.forEach((k) => {
                messaggio += `${k}: ${error.response.data[k]}`
                messaggio += "\n"
              })
              console.log(messaggio)
              this.makeToast("primary", "ERRORE", messaggio);
            }
            return true
          })

      } else {
        // TODO DA GESTIRE
        // salvataggio in caso di edit
        const editUrl = `${apiPraticheVVFUrl}/${this.praticheVVFActiveId}`;
        // qui devo fare caricamento dati ma non include i file da gestire con upload
        error = await useJwt
          .patch(editUrl, this.praticheVVFActiveData)
          .then((res) => {
            // if (res.status == 200 || res.status == 201) {
            //   this.makeToast(
            //     "primary",
            //     "Successo",
            //     "Modifica della praticaVVF"
            //   );
            // }
            console.log(res.status);
            return this; // restituisci contesto per permettere aggiornamento gridA
          })
          .then((context) => {
            const datiDaInviare = {
              annoRiferimento: this.annoRiferimentoCorrente,
            };
            useJwt.post(apiPraticheVVFRicercaUrl, datiDaInviare).then((res) => {
              console.log(
                "Aggiornamento gridA con la modifica di una praticaVVF"
              );
              context.praticheVVFFullData = res.data;
              context.praticheVVFFullData = [...context.praticheVVFFullData];
            });
            return false
          }).catch(error => {
            let messaggio = ""
            if (error.response) {
              //console.log(error.response.data)
              let chiavi = Object.keys(error.response.data)
              // console.log(error.response.data['tipologia'])
              chiavi.forEach((k) => {
                messaggio += `${k}: ${error.response.data[k]}`
                messaggio += "\n"
              })
              console.log(messaggio)
              this.makeToast("primary", "ERRORE", messaggio);
            }
            return true
          })
      }

      if (!error) {
        this.makeToast("primary", "Creazione", "Creazione avvenuta con successo");
        this.$refs.dialogA.hide();
      }
      // triggerare aggiornamento filtering / ordinamento? <----------------------
    },
    dialogACancel() {
      console.log("Cliccato bottone Cancel di dialogA");
      this.$refs.dialogA.hide();
    },
    // per gridA
    gridAClickHandler(args) {
      // pulsante NEW
      const zeroPad = (num, places) => String(num).padStart(places, '0')
      if (args.item.id === "new") {
        this.dialogA.header = "Nuova Pratica VVF";
        const oggi = new Date;
        const mese = oggi.getMonth() + 1
        this.praticheVVFDefaultData = {
          id: 0,
          dataCreazione: oggi,
          recite: null,
          annoRiferimento: oggi.getFullYear().toString(),
          meseRiferimento: zeroPad(mese, 2),
          tariffaOrariaApplicata: null,
          oreTotali: null,
          compensoTotale: null,
          tipo: null,
          stato: "generato",
          fileWordPratica: null,
        };
        this.praticheVVFActiveData = this.praticheVVFDefaultData;
        console.log("Premuto pulsante creazione nuova praticaVVF da gridA");
        // console.log(this.praticheVVFActiveData);
        // console.log(this.praticheVVFDefaultData);
        this.praticheVVFActiveId = 0;
        this.$refs.dialogA.show(true);
      }
      // pulsante EDIT
      else if (args.item.id === "edit") {
        console.log("Premuto pulsante modifica praticaVVF da gridA");
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          let found = false;
          this.praticheVVFActiveId = selectedRow[0].id;
          // console.log("gridA, Id selezionato:");
          console.log(this.praticheVVFActiveId);
          const i = this.praticheVVFFullData.findIndex(
            (x) => x.id === this.praticheVVFActiveId
          );
          if (i >= 0) {
            this.praticheVVFActiveData = this.praticheVVFFullData[i];
            console.log("praticaVVF CORRENTE");
            console.log(this.praticheVVFActiveData);

            const datiDaInviare = {
              spettacolo: this.praticheVVFActiveId,
            };
            useJwt.post(apiReciteRicercaSpettacoloUrl, datiDaInviare).then((d) => {
              // gestione risposta
              this.reciteSpettacoloFullData = d.data;
              console.log("Elenco recite collegate");
              console.log(this.reciteSpettacoloFullData);

              // fix aggiornamento orario
              this.reciteSpettacoloFullData.forEach((obj) => {
                if (obj.orario != null) {
                  //console.log(obj.orario.slice(11, 16));
                  obj.orario = obj.orario.slice(11, 16);
                }
              });
            });

            // spettacolo generico
            console.log("Edit praticaVVF");
            this.dialogA.header = "Modifica praticaVVF";
            this.$refs.dialogA.show(true);
          } else {
            console.log("Elemento non trovato");
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
      // Pulsante DELETE
      else if (args.item.id === "delete") {
        try {
          console.log("Premuto pulsante elimina praticaVVF da gridA");
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          const deletedElementId = selectedRow[0].id;

          const deleteUrl = `${apiPraticheVVFUrl}/${deletedElementId}`;
          useJwt.delete(deleteUrl).then((res) => {
            console.log("Eliminazione avvenuta con successo");
            // console.log(res.data)
          });
          this.$refs.gridA.ej2Instances.deleteRecord();
        } catch (err) {
          // da sistemare..............
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      } else if (args.item.id === "download") {
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          this.praticheVVFActiveId = selectedRow[0].id;
          // console.log("gridA, Id selezionato:");
          const i = this.praticheVVFFullData.findIndex(
            (x) => x.id === this.praticheVVFActiveId
          );
          if (i >= 0) {
            this.praticheVVFActiveData = this.praticheVVFFullData[i];
            console.log("praticaVVF CORRENTE");
            console.log(this.praticheVVFActiveData);
            
            const link = document.createElement("a");
            link.href = this.praticheVVFActiveData['fileWordPratica']
            link.setAttribute("download", "praticaVVF.docx");
            document.body.appendChild(link);
            link.click();
          }
      }
    },
    gridAactionBegin(e) {
      if (!this.gridAFlag) {
        // Add and edit operations
        if (e.requestType === "save") {
          const editedData = e.data;
          console.log(editedData);
          // The default edit operation is cancelled
          e.cancel = true;
          const editUrl = `${apiPraticheVVFUrl}/${editedData.id}`;
          useJwt.patch(editUrl, editedData).then((res) => {
            console.log(res);
            if (res.status === 200) {
              // se tutto OK
              // Flag is enabled to skip this execution when grid ends add/edit
              this.gridAFlag = true;
              // If your data is updated at the server side successfully, we can call the grid endEdit() method to save the edited data to the Grid
              this.$refs.gridA.endEdit();
            } else {
              this.makeToast(
                "primary",
                "Attenzione",
                "Salvataggio praticaVVF non riuscito"
              );
            }
          });
        }
      }
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(e) {
      if (e.requestType === "save") {
        // The flag is disabled after operation is successfully performed so that it can enter the condition on next execution
        this.gridAFlag = false;
      }
    },
    // per click tabs
    tabClicked(args) {
      switch (args) {
        case "dialogATab01":
          console.log("Sei nel primo tab del dialogA");
          break;
        case "dialogATab02":
          console.log("Sei nel secondo tab del dialogA");
          break;
        default:
          console.log(args);
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// seleziono il colore per evidenziare la riga selezionata
.e-grid td.e-active {
  background-color: #e5cbdd;
}
</style>
